import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { Button, Radio, Flex } from "antd"
import SORT from "../constants"
import { Text, Title } from "ui/Typography"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"

const SortOverlay = ({ setSort, setOpen, sortDraft, setSortDraft }) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    setSort(sortDraft)
    setOpen(false)
  }

  const handleReset = () => {
    setSortDraft(SORT.DATE_NEW)
  }

  return (
    <Flex gap={spacings.M} role="menu" aria-label={t("reviews.sort_by", "Sort by")} vertical className={styles.dropdown}>
      <Title level={5}>{t("reviews.sort_by", "Sort by")}</Title>

      <Radio.Group
        value={sortDraft}
        onChange={(e) => {
          const value = e.target?.value
          setSortDraft(value)
        }}
      >
        <Flex gap={spacings.S} vertical>
          <Flex vertical gap={spacings.S}>
            <Text size="md" fw={500}>
              {t("reviews.rating", "Rating")}
            </Text>
            <Radio value={SORT.RATING_HIGH}>{t("reviews.rating_high_to_low", "High to Low")}</Radio>
            <Radio value={SORT.RATING_LOW}>{t("reviews.rating_low_to_high", "Low to High")}</Radio>
          </Flex>

          <Flex vertical gap={spacings.S}>
            <Text size="md" fw={500}>
              {t("reviews.date", "Date")}
            </Text>
            <Radio value={SORT.DATE_NEW}>{t("reviews.date_new_to_old", "New to Old")}</Radio>
            <Radio value={SORT.DATE_OLD}>{t("reviews.date_old_to_new", "Old to New")}</Radio>
          </Flex>
        </Flex>
      </Radio.Group>

      <Flex justify="space-between">
        <Button type="link" onClick={handleReset} className="pl-0">
          {t("reviews.reset_sorting", "Reset Sorting")}
        </Button>
        <Button type="primary" onClick={handleConfirm}>
          {t("common.confirm", "Confirm")}
        </Button>
      </Flex>
    </Flex>
  )
}

SortOverlay.propTypes = {
  setSort: PropTypes.func,
  setOpen: PropTypes.func,
  sortDraft: PropTypes.string,
  setSortDraft: PropTypes.func
}

export default SortOverlay
